import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { DirectivesModule } from '../../directives';
import { AutocompleteModule } from '../autocomplete/autocomplete.module';
import { CardModule } from '../card/card.module';
import { GridModule } from '../grid/grid.component.module';
import { PaginatorModule } from '../paginator/paginator.module';
import { RefreshButtonModule } from '../refresh-button';
import { ToolbarModule } from '../toolbar';
import { ObjectBrowserFilterComponent } from './filter/filter.component';
import { ObjectBrowserComponent } from './object-browser.component';
import { ObjectBrowserSelectionComponent } from './selection/selection.component';
import { SitesMapComponent } from './sites-map/sites-map.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TwcModule,
        TranslateModule,
        CardModule,
        ToolbarModule,
        PaginatorModule,
        GridModule,
        DirectivesModule,
        RefreshButtonModule,
        AutocompleteModule,
    ],
    exports: [ObjectBrowserComponent, ObjectBrowserSelectionComponent],
    declarations: [ObjectBrowserComponent, ObjectBrowserFilterComponent, SitesMapComponent, ObjectBrowserSelectionComponent],
    providers: [],
})
export class ObjectBrowserModule {}
